import styled from 'styled-components';
import { animations } from 'src/components/base';

export const StyledPriceHistorySummary = styled.div.attrs({
  'data-test': 'PriceHistorySummary',
})`
  min-height: 151px;
  background: ${props => props.theme.bg.secondary};
  border-radius: 8px;
`;

export const StyledFadingBox = styled.div`
  background: ${props => props.theme.bg.primary};
  border-radius: 8px;
  animation: ${animations.fadeInKeyframes} 0.1s;
`;

export const StyledPriceHistoryHeading = styled.span`
  color: ${props => props.theme.colors.base500};
  float: left;
`;

export const StyledPriceHistoryWrapper = styled.div`
  position: relative;
`;

export const StyledCurrentPrice = styled.div`
  text-align: right;
  color: ${props => props.theme.colors.base500};
  font-weight: 600;
`;
